import script from "./base-multiselect.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-multiselect.vue?vue&type=script&setup=true&lang=ts"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./base-multiselect.vue?vue&type=style&index=1&id=5e6e7f5b&lang=scss"

const __exports__ = script;

export default __exports__